




















































import { Component } from 'vue-property-decorator';
import { ITag, TagCategory, TaskModel, TaskStatus } from 'admiral-core';
import { CalendarIcon, CircleIcon, DiscIcon, XIcon } from 'vue-feather-icons';
import Multiselect from 'vue-multiselect';
import PolicyTimeline from '@/views/pages/policies/PolicyTimeline.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { TaskApi } from '@/services/TaskApi';
import { TagApi } from '@/services/TagApi';
import PolicySelect from '@/components/common/selects/PolicySelect.vue';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import TaskForm from '@/forms/TaskForm.vue';
import { FormMixin } from '@/mixins/FormMixin';
import { BModal } from 'bootstrap-vue';
import CommentBox from '../../../components/common/CommentBox.vue';

@Component({
  components: {
    TaskForm,
    UserSelect,
    PolicySelect,
    PolicyTimeline,
    CircleIcon,
    DiscIcon,
    Multiselect,
    CalendarIcon,
    XIcon,
  },
})
export default class CreateTaskModal extends mixins(BaseMixin, FormMixin) {
  tags: ITag[] = [];

  model = this.defaultModel();
  isLoading2 = false;
  isDone2 = false;

  defaultModel(): TaskModel {
    return {
      title: '',
      description: '',
      status: TaskStatus.TODO,
      users: [this.user],
      tags: [],
      files: [],
      newUploadedFiles: [],
      newComments: [],
      isPrivate: false,
    };
  }

  async mounted() {
    this.$root.$on('bv::modal::show', async (bvEvent: Event, modalId: string) => {
      if (modalId === 'create-task') {
        await this.loadTags();
      }
    });

    this.model = { ...this.defaultModel() };
  }
  async destroyed() {
    this.$root.$off('bv::modal::show');
  }

  async ok(evt: Event) {
    evt.preventDefault();
    try {
      this.isLoading = true;

      // access value in taskform->commentbox component
      const taskForm = this.$refs['taskform'] as TaskForm;
      const commentbox = taskForm.$refs['commentbox'] as any;

      if (commentbox.value?.text) {
        this.model.newComments!.push({
          id: 'new-comment',
          text: commentbox.value?.text,
          createdAt: new Date(),
          updatedAt: new Date(),
          user: this.user!,
          isDemo: false,
        });
      }

      const response = await TaskApi.create({
        title: this.model.title,
        description: this.model.description,
        users: this.model.users,
        dueAt: this.model.dueAt,
        priority: this.model.priority,
        status: this.model.status,
        tags: this.model.tags,
        agency: this.agency,
        newUploadedFiles: this.model.newUploadedFiles,
        newComments: this.model.newComments,
        isPrivate: this.model.isPrivate,
        customer: this.model.customer?.trim() || '',
        customerId:
          taskForm.findCrmCustomerOption(this.model.customer || '')?.id ||
          this.model.customerId ||
          undefined,
      });
      this.model = { ...this.defaultModel() };
      this.$emit('reload');
      this.$emit('create-task', response.data);
      this.$nextTick(() => {
        (this.$refs['create-task'] as BModal).hide();
      });
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern der Aufgabe ist etwas schief gelaufen.', 'Oops');
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(
      apiErrors['titleisNotEmpty'] || apiErrors['titleminLength'],
      'title',
      'Bitte eine Bezeichnung für die Aufgabe angeben.',
    );
  }

  async cancel() {
    this.model = { ...this.defaultModel() };
  }

  async loadTags() {
    try {
      const response = await TagApi.getTags({
        agency: this.user.agency,
        category: TagCategory.Tasks,
      });
      this.tags = response.data;
    } catch (e) {
      console.log(e);
    }
  }

  async addTag(name: string) {
    try {
      const response = await TagApi.create({
        tag: {
          name,
        },
      });

      const newTag = response.data;

      if (!this.model.tags) {
        this.model.tags = [];
      }
      this.model.tags.push(newTag);
    } catch (e) {
      console.log(e);
    }
  }
}
